import React, { FunctionComponent } from 'react'

import { AuctionMonitoringRecord } from '../../../common/auctionMonitoringTypes'
import {
  AuctionListingFilter,
  useAuctionMonitoringTabQuery,
} from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { useAuctionLabelIds } from '../../utils/useAuctionLabelIds'
import { AuctionDetailDrawer } from '../AuctionDetailDrawer/AuctionDetailDrawer'
import AuctionMonitoringTable from '../AuctionMonitoringTable/AuctionMonitoringTable'
import { PropertyDetailDrawer } from '../PropertyDetailDrawer/PropertyDetailDrawer'

export interface AuctionLabelTableProps {
  auctionListingFilter?: AuctionListingFilter
}

export const AuctionLabelTable: FunctionComponent<AuctionLabelTableProps> =
  props => {
    const accountUserId = useAppSelector(state => state.myProfile.userId)
    const accountId = useAppSelector(state => state.myProfile.tenantId)
    const labelIds = useAuctionLabelIds()

    const [dataSource] = useAuctionMonitoringTabQuery({
      variables: {
        filter: props.auctionListingFilter,
        accountUserId,
        accountId,
        labelIds: labelIds.data,
      },
    })
    return (
      <>
        <AuctionMonitoringTable
          auctionListingFilter={props.auctionListingFilter}
          viewType="page"
          loading={dataSource.fetching || labelIds.fetching}
          data={
            dataSource?.data?.allAuctionListings
              ?.nodes as unknown as AuctionMonitoringRecord[]
          }
        />
        <PropertyDetailDrawer />
        <AuctionDetailDrawer />
      </>
    )
  }
